import { render, staticRenderFns } from "./CardSectionAwardsSlider.vue?vue&type=template&id=fce0a53e"
import script from "./CardSectionAwardsSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardSectionAwardsSlider.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports